import { render, staticRenderFns } from "./AccountTypeUpdate.vue?vue&type=template&id=890aa3a2&scoped=true"
import script from "./AccountTypeUpdate.vue?vue&type=script&lang=js"
export * from "./AccountTypeUpdate.vue?vue&type=script&lang=js"
import style0 from "./AccountTypeUpdate.vue?vue&type=style&index=0&id=890aa3a2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "890aa3a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('890aa3a2')) {
      api.createRecord('890aa3a2', component.options)
    } else {
      api.reload('890aa3a2', component.options)
    }
    module.hot.accept("./AccountTypeUpdate.vue?vue&type=template&id=890aa3a2&scoped=true", function () {
      api.rerender('890aa3a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/schoolconfig/account/AccountTypeUpdate.vue"
export default component.exports